import { render, staticRenderFns } from "./CustomizeTabsPanel.vue?vue&type=template&id=c8a6e5c2&scoped=true&"
import script from "./CustomizeTabsPanel.vue?vue&type=script&lang=js&"
export * from "./CustomizeTabsPanel.vue?vue&type=script&lang=js&"
import style0 from "./CustomizeTabsPanel.vue?vue&type=style&index=0&id=c8a6e5c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8a6e5c2",
  null
  
)

export default component.exports